import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'smart-highchart-history',
  templateUrl: './highchart-history.component.html',
  styleUrls: ['../graph-color.css','./highchart-history.component.scss']
})
export class HighchartHistoryComponent implements OnInit {
  colorSetting = [
    "",
    "#7cb6ec",
    "#8085e9",
    "#434348",
    "#90ed7d"
  ]
  @Input() reportLeft = [];
  @Input() reportRight = [];
  filter: boolean = false;

  Highcharts: typeof Highcharts = Highcharts;

  chartOptions: Highcharts.Options = {
    chart: {
      scrollablePlotArea: {
        minWidth: 600,
        scrollPositionX: 1
      }
    },
    title:{
      text:''
    },
    plotOptions: {
      series: {
        showInNavigator: true
      },
      spline: {
        lineWidth: 3,
        states: {
          hover: {
            lineWidth: 4
          }
        },
        marker: {
          enabled: true,
          radius: 4
        }
      }
    },
    rangeSelector: {
      enabled:false
    },
    legend: {
      enabled: true
    },
    yAxis: [],
    tooltip: {
      shared: true
    },
    series: [],
    xAxis: {
      type: 'datetime',
    },
    exporting:{
      enabled: false
    }
  };
  noData: boolean = false;

  constructor(
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  async ngOnChanges(changes: SimpleChanges) {

    this.filter = false;

    setTimeout(async () => {

      await this.plotGraph();
    }, 500);
  }

  async plotGraph(){

    let yAxis = [];
    let series = [];
    await Promise.all(this.reportLeft.map(async sensor=>{

      if(yAxis.find(y=>y.opposite == false && y.sensor_unit == sensor.sensor_unit)){

      }else{
        yAxis.push(
          {
            gridLineWidth: 0,
            title: {
                text: sensor.points[0].sensor_name,
                style: {
                    color: this.colorSetting[yAxis.length+1]
                }
            },
            labels: {
                format: '{value} ' + sensor.points[0].sensor_unit,
                style: {
                    color: this.colorSetting[yAxis.length+1]
                }
            },
            opposite:false,
            sensor_unit: sensor.points[0].sensor_unit
          }
        );
      }
      let data = [];

      await Promise.all(sensor.points.map(async v=>{
        data.push(
          [new Date(v.fromTime).getTime(), parseFloat(v.value)]
        )
      }));

      series.push(
        {
          name: sensor.points[0].sensor_name,
          data: data,
          tooltip: {
            valueSuffix: ' ' + sensor.points[0].sensor_unit
          },
          color: this.colorSetting[series.length+1],
          opposite:false,
          sensor_unit: sensor.points[0].sensor_unit
        }
      )
    }));
    
    await Promise.all(this.reportRight.map(async sensor=>{
      if(yAxis.find(y=>y.opposite == true && y.sensor_unit == sensor.sensor_unit)){

      }else{
        yAxis.push(
          {
            gridLineWidth: 0,
            title: {
                text: sensor.points[0].sensor_name,
                style: {
                    color: this.colorSetting[yAxis.length+1]
                }
            },
            labels: {
                format: '{value} ' + sensor.points[0].sensor_unit,
                style: {
                    color: this.colorSetting[yAxis.length+1]
                }
            },
            opposite:true,
            sensor_unit: sensor.points[0].sensor_unit
          }
        );
      }
      let data = [];
      
      await Promise.all(sensor.points.map(async v=>{
        data.push(
          [new Date(v.fromTime).getTime(), parseFloat(v.value)]
        )
      }));

      series.push(
        {
          name: sensor.points[0].sensor_name,
          data: data,
          tooltip: {
            valueSuffix: ' ' + sensor.points[0].sensor_unit
          },
          color: this.colorSetting[series.length+1],
          opposite:true,
          sensor_unit: sensor.points[0].sensor_unit
        }
      )
    }));
    
    await Promise.all(series.map(async (item, index)=>{
      let findIndex = yAxis.findIndex(y=> y.opposite == item.opposite && item.sensor_unit == y.sensor_unit);

      series[index].yAxis = findIndex;
    }));

    await Promise.all(yAxis.map(async (item, index)=>{
      let findSeries = series.find(s=> s.opposite == item.opposite && item.sensor_unit == s.sensor_unit);

      yAxis[index].title.style.color = findSeries.color;
      yAxis[index].labels.style.color = findSeries.color;
    }));

    this.chartOptions.yAxis = yAxis;
    this.chartOptions.series = series;

    this.noData = false;

    if(yAxis.length > 0){
      setTimeout(() => {
        this.loadFilter();
      }, 200);
    }else{
      this.noData = true;
      this.loadFilter();
    }
  }

  loadFilter(){
    this.filter = true;
    this.cd.detectChanges();
  }
}